import { render, staticRenderFns } from "./Step3WhoPays.vue?vue&type=template&id=03485b46"
import script from "./Step3WhoPays.vue?vue&type=script&lang=js"
export * from "./Step3WhoPays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports